
import axios from 'axios'
import config from '../config'
import auth from './auth'
export default {


    getDeslindeSignatureByToken(token) {
        return axios.get(`${config.api_base_url}v1/inscripciones/deslindes/${token}`)
    },

    getDeslindes(evento_id, filters){

        let params =  new URLSearchParams(filters).toString();
        params = params ? `?${params}` : '';
        return axios.get(`${config.api_base_url}evento/${evento_id}/deslindes${params}`)
            .then((res) => {return res.data})
            .catch(res=>{                 
                if(res.response){                   
                    if(res.response.status == 401){
                        auth.logout();
                    }else{
                        throw res;                
                    }
                }else{
                    throw res;
                }
            }); 
    }

}